import { TGetColor, GlobalColorKeyword } from './types';
import { DEFAULT_COLOR_PALETTE } from './constants';

export const getColor: TGetColor = (component, theme, customColor) => {
  // Without a customColor we default to the default color palette
  if (!customColor) {
    return DEFAULT_COLOR_PALETTE[component][theme.name];
  }

  // Given as {light: '', dark: ''} notation
  if (typeof customColor === 'object') {
    return customColor[theme.name];
  }

  // Given as a global CSS color keyword
  if (GlobalColorKeyword[customColor]) {
    return GlobalColorKeyword[customColor];
  }

  // Given as a color from our global color list
  return customColor;
};
